import { render, staticRenderFns } from "./ItemWriteCollectionLayout.vue?vue&type=template&id=364755a2&scoped=true&"
import script from "./ItemWriteCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364755a2",
  null
  
)

export default component.exports